import { generateLabelsAndValues } from "../utils/HelperFunctions";


export const BULK_REGISTRATION_STATUS = {
    QR_CODE: 1,
    EXCEL_SHEET: 2,
    BULK_UPLOAD_CPD: 3,
}

export const BULK_REGISTRATION_LABELS_VALUES =
    generateLabelsAndValues(BULK_REGISTRATION_STATUS);

export const BULK_REGISTRATION_STATUS_TABS = [
    {
        name: "QR Code",
        status: BULK_REGISTRATION_STATUS.QR_CODE,
    },
    {
        name: "Excel Sheet",
        status: BULK_REGISTRATION_STATUS.EXCEL_SHEET,
    },
    {
        name: "Bulk Upload CPD",
        status: BULK_REGISTRATION_STATUS.BULK_UPLOAD_CPD,
    },
];
